import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-49c1d39a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "container_box"
}
const _hoisted_5 = { class: "container_left" }
const _hoisted_6 = { class: "problems" }
const _hoisted_7 = { class: "exam_tips_box" }
const _hoisted_8 = { class: "exam_tips" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = {
  key: 0,
  class: "no_result"
}
const _hoisted_11 = {
  key: 1,
  class: "item"
}

import { ref, onMounted } from 'vue'
  import axios from 'axios'
  import store from "@/store"
  import UserInfo from '@/components/user-info.vue'
  import QuList from '@/components/quList.vue'
  import TheFooter from '@/components/the-footer.vue'
  import Item from '@/components/item.vue'
  import MsgBox from '@/components/MsgBox.vue'
  import Time from '@/components/Time.vue'
  import TimeUp from '@/components/time-up.vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import {useRouter} from 'vue-router'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

  const router = useRouter();
  const { params } = router.currentRoute.value
  
  const qList:any = ref([])
  const loading:boolean = ref(false)
  const index:number = ref(0);
  const examinationRecordId:string = params.enrollId
  const planId:string = params.planId
  const planstudentId:string = params.planstudentId
  const curItem:any =ref({})
  const isShowScore:boolean = ref(false)
  const msgText:string = ref('')
  const score:number = ref(0)
  const examConfig:any = ref({})
  const tips:string = ref('')
  const sysTime:any = ref(null)
  const planInfo:any = ref({})
  const examinationInfo:any = ref({})
  const isLoading:boolean = ref(true)
  const isTimeUp:boolean = ref(false)
  const progress:number = ref(0)
  const question:any = store.state.question
  const questionList:any = []
  let loadingInstance:any = null
  const isShowExamre:boolean = ref(true)

  onMounted(() => {
    getExamTime()
  })

  const getExaminationRecord = async () => {
    let { data } = await axios.get(`/api/exam-end/getExaminationRecord/${examinationRecordId}/${planId}/${planstudentId}`)
    if ( data.code === 200 ) {
      examinationInfo.value = data.data
      getAnswer(data.data)
    } else {
      ElMessage.error(data.msg || "获取失败...")
      loadingInstance.close()
      await router.push({
        name: 'Home'
      })
    }
  }

  const getTrainPlan = async () => {
    let { data } = await axios.get(`/api/exam-end/trainPlan/${planId}`)
    if ( data.code === 200 ) {
      examConfig.value = data.data
      getExaminationRecord()
    } else {
      ElMessage.error(data.msg || "获取失败...")
    }
  }

  const planInfoHandler = async () => {
    let { data } = await axios.get(`/api/exam-end/plan/${planId}`)
    if ( data.code === 200 ) {
      planInfo.value = data.data
      getTrainPlan()
    } else {
      ElMessage.error(data.msg || "获取失败...")
    }
  }

  const getExamTime = async () => {
    loadingInstance = ElLoading.service({ fullscreen: true, text: '正在获取试卷...' })
    let { data } = await axios.get(`/api/exam-end/time`)
    if ( data.code === 200 ) {
      sysTime.value = data.data
      planInfoHandler()
    } else {
      ElMessage.error(data.msg || "获取失败...")
    }
  }

  const getTipsHandle = (item:any) => {
    let eConfig = examConfig.value
    if (item.questionType === 1) {
      tips.value = `单选题（共${eConfig.single}题 每题${eConfig.singleScore}分 共${eConfig.single*eConfig.singleScore}分）`
    }
    if (item.questionType === 2) {
      tips.value = `多选题（共${eConfig.multiple}题 每题${eConfig.multipleScore}分 共${eConfig.multiple*eConfig.multipleScore}分）`
    }
    if (item.questionType === 3) {
      tips.value = `判断题（共${eConfig.yesOrNo}题 每题${eConfig.yesOrNoScore}分 共${eConfig.yesOrNo*eConfig.yesOrNoScore}分）`
    }
  }

  const timeUpHandler = () => {
    isTimeUp.value = true
  }

  const getAnswer = async (item:any) => {
    if ( qList.value.length > 0 ) {
      ElMessage.error("已获取过试卷，请勿重复获取！")
      return
    }
    let { data }  = await axios.get(`/api/exam-end/question/${item.id}`)
    
    loadingInstance.close()
    isLoading.value = false;
    if ( data.code === 200 ) {
      let progressIdx = 0
      if ( data.rows.length ) {
        data.rows.map((item:any) => {
          item.questionSnapshots = JSON.parse(item.questionSnapshots)
          item.questionAnswer = []
          let answerList = []
          let temp = question.find((q:any) => q.id === item.id)
          let list = []
          let qATemp = {
            id: item.id,
            answers: [],
            state: 2,
            mark: false
          }
          if ( temp ) {
            if ( temp.answers.length > 0 ) {
              progressIdx++
              item.answerList = temp.answers
              qATemp.answers = temp.answers
              qATemp.state = temp.state
              if ( temp.state === 1 ) {
                item.selected = true
              }
              if ( temp.state === 3 ) {
                item.mark = true
                qATemp.mark = true
              }
            }
            list = temp.answers
          }
          let idx = 0
          for ( let n in item.questionSnapshots ) {
            if ( /answer\d/.test(n) ) {
              if ( list.includes(idx) ) {
                answerList.push({ title: item.questionSnapshots[n], isFlag: true })
              } else {
                answerList.push({ title: item.questionSnapshots[n], isFlag: false })
              }
              idx++
            }
          }
          item.answers = answerList
          item.answerList = []
          questionList.push(qATemp)
          item.mark = false
          item.questionType = item.questionSnapshots.questionType
          
          return item
        })
        qList.value = data.rows;
        store.commit('setQuestion', questionList)
        updateCurItem(0)
        progress.value = progressIdx
      } else {
        ElMessage.error("未获取到相关试卷！")
      }
      
    } else {
      ElMessage.error("未获取到相关试卷！")
    }
  }

  const updateCurItem = (i:number) => {
    index.value = i
    let item = qList.value[index.value]
    curItem.value = item
    getTipsHandle(item)
  }

  const previousHandler = () => {
    if ( index.value < 1 ) {
      ElMessage.error("当前是第一题")
      return
    }
    index.value--
    updateCurItem(index.value)
  }

  const nextHandler = () => {
    if ( index.value >= qList.value.length ) {
      ElMessage.error("当前是最后一题")
      return
    }
    index.value++
    updateCurItem(index.value)
  }

  const changStatusHandler = (item:any, flag: boolean) => {
    item.mark = flag
    let q = questionList.find((q:any) => q.id === item.id)
    q.state = 3
    store.commit('setQuestion', questionList)
  }

  const changSelectedHandler = (item:any) => {
    item.selected = item.answerList.length == 0 ? false : true
    let q = questionList.find((q:any) => q.id === item.id)
    q.answers = item.answerList
    q.state = item.selected ? 1 : 2
    store.commit('setQuestion', questionList)
    let progressIdx = 0
    questionList.map((q:any) => {
      if ( q.answers.length > 0 ) {
        progressIdx++
      }
    })
    progress.value = progressIdx
  }

  const goHome = () => {
    router.replace({
      name: 'Home'
    })
  }


  const submitHandler = async (flag: boolean) => {
    loadingInstance = ElLoading.service({ fullscreen: true, text: '交卷中...' })
    loading.value = flag;
    let { data } = await axios.post(`/api/exam-end/commit-paper/${examinationInfo.value.id}`, {
      answers: questionList
    });
    loadingInstance.close()
    if ( data.code === 200 ) {
      store.commit('setQuestion', [])
      getScore()
    } else {
      ElMessage.error(data.msg || "提交失败，请稍后再试！")
    }
  }

  // const retryHandler = async () => {
  //   qList.value = []
  //   isShowScore.value = false
  //   index.value = 0
  //   let { data } = await axios.post(`/api/exam-end-mock/remove/examrecord/${examinationRecordId}/${params.postionType}/${params.stageCode}`);
  //   if ( data.code === 200 ) {
  //     getAnswer()
  //   }
  // }

  const getScore = async () => {
    let { data } = await axios.post(`/api/exam-end/examrecord/${examinationInfo.value.id}`);
    if ( data.code === 200 ) {
      score.value = data.data.score
      if ( data.data.score > 80 ) {
        msgText.value = '恭喜您顺利通过考试！'
      } else {
        msgText.value = '很遗憾您未通过考试，请继续努力！'
      }
      isShowScore.value = true
      isShowExamre.value = false
    } else {
      ElMessage.error(data.msg || "获取分数失败，请稍后再试！")
    }
  }
  window.onbeforeunload = function(e) {
    console.log('beforeunload')
    return 1;
  };

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (isShowExamre.value)
      ? (_openBlock(), _createBlock(_component_el_container, { key: 0 }, {
          default: _withCtx(() => [
            (!isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(UserInfo, { data: qList.value }, null, 8, ["data"]),
                    _createVNode(QuList, {
                      data: qList.value,
                      progress: progress.value,
                      index: index.value,
                      onChoose: updateCurItem
                    }, null, 8, ["data", "progress", "index"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(tips.value), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(Time, {
                          examMinutes: planInfo.value.examMinutes,
                          sysTime: sysTime.value,
                          paperTime: examinationInfo.value,
                          onTimeUp: timeUpHandler
                        }, null, 8, ["examMinutes", "sysTime", "paperTime"])
                      ])
                    ]),
                    _createVNode(_component_el_main, { class: "content" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, {
                          class: "bg-color",
                          justify: "center"
                        }, {
                          default: _withCtx(() => [
                            (qList.value.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _createTextVNode(" 未获取到相关试卷 "),
                                  _createVNode(_component_el_button, {
                                    onClick: goHome,
                                    size: "large",
                                    type: "danger"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("重新选择")
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  (_openBlock(), _createBlock(Item, {
                                    data: curItem.value,
                                    index: index.value,
                                    key: index.value,
                                    examinationRecordId: _unref(examinationRecordId),
                                    onChangSelected: changSelectedHandler,
                                    onChangStatus: changStatusHandler
                                  }, null, 8, ["data", "index", "examinationRecordId"]))
                                ]))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (qList.value.length > 0)
                      ? (_openBlock(), _createBlock(TheFooter, {
                          data: curItem.value,
                          key: index.value,
                          loading: loading.value,
                          onSubmitQuestion: submitHandler,
                          onPrevious: previousHandler,
                          onNext: nextHandler
                        }, null, 8, ["data", "loading"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (isTimeUp.value)
              ? (_openBlock(), _createBlock(TimeUp, {
                  key: 1,
                  onSubmitQuestion: submitHandler
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (isShowScore.value)
      ? (_openBlock(), _createBlock(MsgBox, {
          key: 1,
          score: score.value,
          msgText: msgText.value,
          onCallback: goHome
        }, null, 8, ["score", "msgText"]))
      : _createCommentVNode("", true)
  ]))
}
}

})